import { useEffect, useRef, RefObject } from 'react'

/* USE MOUNTED */

export const useMounted = (): RefObject<boolean> => {
  const mounted = useRef(false)

  useEffect(() => {
    mounted.current = true
    return () => {
      mounted.current = false
    }
  }, [])

  return mounted
}
